import { FlexLayout, H4 } from '@deity/falcon-ui';
import type { FC } from 'react';

interface IStaticPropertyProps {
  property: string;
  value: string | number;
}
const StaticField: FC<IStaticPropertyProps> = ({ property, value }) => (
  <FlexLayout style={{ textTransform: 'capitalize' }} mb="lg">
    <H4 color="primaryText" fontWeight="bold" mr="xs">
      {property}
    </H4>
    <H4 fontWeight="bold" color="secondary">
      {value}
    </H4>
  </FlexLayout>
);

export default StaticField;
